import type { ReactNode } from 'react';
import { useHydrated } from 'remix-utils';

import {
    MagicIsland,
    MagicIslandProvider,
} from '~/ui-rocco/pages/detail-shared';

interface ProfessionalDetailsMagicIslandProps {
    children: ReactNode;
}

/**
 * Professional-detail wrapper for the Magic Island. Mounted once in the
 * persistent layout ({@link ProfessionalPage}) — so a single controller + shell
 * survives tab navigation (the hero persists there too), and every tab's
 * sections can register their island modes against the same controller. It is
 * only rendered when the revamp layout is active, so it needs no flag of its
 * own; the shell is client-only (`useHydrated`) so the server renders nothing
 * and there is no hydration shift.
 */
export const ProfessionalDetailsMagicIsland = ({
    children,
}: ProfessionalDetailsMagicIslandProps) => {
    const hydrated = useHydrated();

    return (
        <MagicIslandProvider>
            {children}
            {hydrated ? <MagicIsland /> : null}
        </MagicIslandProvider>
    );
};
